export default __webpack_public_path__ + "static/media/FraunhoferJoke-DE.e7c68774.mp4";